﻿import { iconClassName, localText } from "@serenity-is/corelib";

export function AddonTextWithIcon(props: { text: string, icon: string }): any {
    const { text, icon } = props;
    return (<>
        {icon && <i class={["addon-icon", iconClassName(icon)]} />}
        <span class={["addon-text", icon && "ms-1"]}>{localText(text, text)}</span>
    </>)
}